<div class="qs-page">

  <!-- Header -->
  <div class="qs-header">
    <button type="button" class="qs-header__back" (click)="goBack()">
      ‹ Back to Al-Quran
    </button>
    <div class="qs-header__title-wrap">
      <span class="qs-header__icon">📋</span>
      <h1 class="qs-header__title">All Surahs</h1>
      <span class="qs-header__count">114 Surahs · 30 Juz'</span>
    </div>
  </div>

  <div class="qs-body">

    <!-- Juz Sidebar -->
    <aside class="qs-sidebar">
      <div class="qs-sidebar__label">Juz'</div>

      <button type="button"
              class="qs-juz-btn"
              [class.qs-juz-btn--active]="selectedJuz() === null"
              (click)="selectJuz(null)">
        All
      </button>

      @for (j of juzNumbers; track j) {
        <button type="button"
                class="qs-juz-btn"
                [class.qs-juz-btn--active]="selectedJuz() === j"
                (click)="selectJuz(j)">
          {{ j }}
        </button>
      }
    </aside>

    <!-- Surah list grouped by Juz -->
    <main class="qs-main">

      @for (group of juzGroups(); track group.juz) {

        <div class="qs-juz-group">
          <div class="qs-juz-group__header">
            <div class="qs-juz-group__badge">Juz' {{ group.juz }}</div>
            <div class="qs-juz-group__line"></div>
            <div class="qs-juz-group__meta">{{ group.surahs.length }} Surahs</div>
          </div>

          <div class="qs-surah-grid">
            @for (s of group.surahs; track s.number) {
              <div class="qs-surah-item">
                <div class="qs-surah-item__num">{{ s.number }}</div>
                <div class="qs-surah-item__info">
                  <div class="qs-surah-item__arabic">{{ s.arabic }}</div>
                  <div class="qs-surah-item__name">{{ s.name }}</div>
                  <div class="qs-surah-item__translation">{{ s.translation }}</div>
                </div>
                <div class="qs-surah-item__right">
                  <span class="qs-surah-item__type" [class.qs-surah-item__type--madani]="s.type === 'madani'">
                    {{ s.type === 'makki' ? 'Makki' : 'Madani' }}
                  </span>
                  <span class="qs-surah-item__ayahs">{{ s.ayahs }} Ayahs</span>
                </div>
                <div class="qs-surah-item__arrow">›</div>
              </div>
            }
          </div>
        </div>

      }

      @if (juzGroups().length === 0) {
        <div class="qs-empty">No surahs found.</div>
      }

    </main>
  </div>
</div>
